<!-- App.vue -->
<template>
  <div id="app">
    <!-- router-view 会根据当前路由渲染对应组件 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
